import { createSlice } from "@reduxjs/toolkit";

const posProductsSlice = createSlice({
  name: "posProducts",
  initialState: [],
  reducers: {
    updateToPosProducts: (state, action) => {
      const { ItemC, updatedItem } = action.payload;
      const index = state.findIndex((item) => item.ItemC === ItemC);
      if (index !== -1) {
        state[index] = { ...state[index], ...updatedItem };
      }
    },
    resetItems: () => {
      return [];
    },
    // Reset all quantities to 0 while keeping products in the array
    resetQuantities: (state) => {
      return state.map((item) => ({
        ...item,
        qty: 0,
        total: 0,
        taxAmt: 0,
      }));
    },
    setPosProducts: (state, action) => {
      return action.payload;
    },
  },
});

export const { updateToPosProducts, resetItems, resetQuantities, setPosProducts } =
  posProductsSlice.actions;
export default posProductsSlice.reducer;
